import { useEffect, useState } from "react";
import {
  getResponsiveBadgeSize,
  getResponsiveFontSizes,
  getResponsiveSpacing,
} from "../sidebarStyles";

// ===== RESPONSIVE SCREEN SIZE DETECTION =====
// Breakpoint flags + derived responsive values, updated on window resize.
export const useResponsiveBreakpoints = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth <= 1024 && window.innerWidth > 768
  );
  const [isSmallLaptop, setIsSmallLaptop] = useState(
    window.innerWidth <= 1366 && window.innerWidth > 1024
  );
  const [isLargeLaptop, setIsLargeLaptop] = useState(
    window.innerWidth <= 1920 && window.innerWidth > 1366
  );
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1920);

  const [badgeSize, setBadgeSize] = useState(getResponsiveBadgeSize());
  const [fontSizes, setFontSizes] = useState(
    getResponsiveFontSizes(window.innerWidth <= 768, window.innerWidth <= 1024 && window.innerWidth > 768)
  );
  const [spacing, setSpacing] = useState(
    getResponsiveSpacing(window.innerWidth <= 768, window.innerWidth <= 1024 && window.innerWidth > 768)
  );

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      setIsMobile(width <= 768);
      setIsTablet(width <= 1024 && width > 768);
      setIsSmallLaptop(width <= 1366 && width > 1024);
      setIsLargeLaptop(width <= 1920 && width > 1366);
      setIsDesktop(width > 1920);

      setBadgeSize(getResponsiveBadgeSize());
      setFontSizes(
        getResponsiveFontSizes(width <= 768, width <= 1024 && width > 768)
      );
      setSpacing(
        getResponsiveSpacing(width <= 768, width <= 1024 && width > 768)
      );
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isMobile,
    isTablet,
    isSmallLaptop,
    isLargeLaptop,
    isDesktop,
    badgeSize,
    fontSizes,
    spacing,
  };
};
